import React from 'react';
import { shapeFixer, RATIO_1x1,  } from '../../../util/imageUtils';

import './scss/ShapeFixer.scss';

const ShapeFixer = (props) => {
    const className= props.className || '';

	return (<React.Fragment>
		<img className={`vtn-shape-fixer ${className ? className : ''}`} src={shapeFixer(props.ratio || RATIO_1x1)} alt={props.alt}/>
	</React.Fragment>);
};

export default ShapeFixer;